module.exports = __webpack_public_path__ + "media/summon.b00d528a.mp4";